import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, makeStyles, MenuItem, Select, useMediaQuery } from '@material-ui/core'
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  select: {
    fontSize: theme.typography.pxToRem(18),
    minWidth: 146,
    [theme.breakpoints.up('md')]: {
      backgroundColor: '#fff',
      boxShadow: '0px 2px 2px #70707066',
      '& .MuiSelect-select:focus': {
        backgroundColor: 'inherit',
      },
    },
  },
}))

const Sorting = ({ onChange, placeholder, options, value }) => {
  const classes = useStyles()
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('md'))

  return (
    <FormControl>
      <Select
        className={classes.select}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        onChange={(event) => onChange(event.target.value)}
        value={value}
        variant={isDesktop ? 'outlined' : 'standard'}
      >
        <MenuItem disabled value="">
          {placeholder}
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

Sorting.defaultProps = {
  placeholder: '',
}

Sorting.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
}

export default Sorting
